module.exports = __webpack_public_path__ + "static/media/tech-job-2.3bbd9783.png";